import { useEffect } from 'react';

import { sendTopicView } from '../services/topicView';

/**
 * Signale une vue de sujet forum au montage client de la page topic.
 *
 * Remplace le comptage émis par le rendu serveur, qui doublait chaque visite
 * dès que l'ISR régénérait la page en arrière-plan (voir `services/topicView`,
 * qui porte le détail de la fenêtre anti-rebond et de la revisite).
 * Client-only (no-op en SSR), no-op tant que `threadId` est absent.
 *
 * Monté sur les deux surfaces qui affichent un sujet et résolvent son thread
 * côté serveur : la page topic (`ThreadPageTopicLoaded`) et la page de
 * deep-link message / discussion Yakli (`Discussion`). Le serveur dérive le
 * site du thread lui-même, donc aucune de ces surfaces n'a à le fournir.
 */
export const useTopicView = (threadId: string | null | undefined): void => {
  useEffect(() => {
    if (!threadId) return;
    sendTopicView(threadId);
  }, [threadId]);
};
